import React, {useEffect, useState} from 'react';
import {useNavigate} from "react-router-dom";

function Payments({color, classes = '', url}) {
    const navigate = useNavigate();
    const onMenuClick = () => {
        navigate(`/${url}`);
    }
    return (
        <div className={classes} onClick={onMenuClick}>
            <svg id="payments" xmlns="http://www.w3.org/2000/svg" width="18" height="19.385" viewBox="0 0 18 19.385">
                <path fill={color} id="payments-2" data-name="payments" d="M6,3V21H17.077V19.615H7.385V4.385h6.923V8.538h4.154V9.923h1.385V7.569l-.208-.207L15.484,3.208,15.277,3Zm9.692,2.354,1.8,1.8h-1.8ZM8.769,9.923v1.385h8.308V9.923Zm11.769,1.385v1.385a2.457,2.457,0,0,0-2.077,2.423,2.366,2.366,0,0,0,2.423,2.423h.692a1.038,1.038,0,0,1,0,2.077H19.154V21h1.385v1.385h1.385V21A2.457,2.457,0,0,0,24,18.577a2.366,2.366,0,0,0-2.423-2.423h-.692a1.038,1.038,0,0,1,0-2.077h2.423V12.692H21.923V11.308ZM8.769,13.385v1.385h4.846V13.385Zm6.231,0v1.385h2.077V13.385ZM8.769,16.154v1.385h4.846V16.154Zm6.231,0v1.385h2.077V16.154Z" transform="translate(-6 -3)"/>
            </svg>

        </div>
    );
}

export default Payments;
